import { gql } from "graphql-tag";
import { useQuery } from "@vue/apollo-composable";

// Define your fragment queries here similar to service fragments
export const INDUSTRY_BASIC_INFO = gql`
  fragment IndustryBasicInfo on Industry {
    documentId
    name
    description
    slug
    sub_title
  }
`;

export const INDUSTRY_META_INFO = gql`
  fragment IndustryMetaInfo on Industry {
    meta_tag {
      documentId
      title
      description
      keywords
     
    }
  }
`;

export const INDUSTRY_SERVICES_INFO = gql`
  fragment IndustryServicesInfo on Industry {
    servicesOffered {
      id
      name
      image {
        url
      }
      role
    }
  }
`;

export const INDUSTRY_PROCESSES_INFO = gql`
  fragment IndustryProcessesInfo on Industry {
    DevelopmentProcesses {
      id
      title
      sub_title
      description
    }
  }
`;

export const INDUSTRY_DEMO_INFO = gql`
  fragment IndustryDemoInfo on Industry {
    requestDemo {
      id
      title
      sub_title
      description
    }
  }
`;

export const INDUSTRY_COMPARISON_INFO = gql`
  fragment IndustryComparisonInfo on Industry {
    differentOtherCompanies {
      id
      title
      sub_title
      description
      Keys {
        id
        title
        description
      }
    }
  }
`;

export const INDUSTRY_OFFERS_INFO = gql`
  fragment IndustryOffersInfo on Industry {
    Industries_offers {
      id
      title
      sub_title
      Keys {
        id
        title
        description
      }
    }
  }
`;

// Main query using fragments
export const GET_INDUSTRY_BY_ID = gql`
  query Industry($documentId: ID!) {
    industry(documentId: $documentId) {
      ...IndustryBasicInfo
      ...IndustryMetaInfo
      ...IndustryServicesInfo
      ...IndustryProcessesInfo
      ...IndustryDemoInfo
      ...IndustryComparisonInfo
      ...IndustryOffersInfo
    }
  }
  ${INDUSTRY_BASIC_INFO}
  ${INDUSTRY_META_INFO}
  ${INDUSTRY_SERVICES_INFO}
  ${INDUSTRY_PROCESSES_INFO}
  ${INDUSTRY_DEMO_INFO}
  ${INDUSTRY_COMPARISON_INFO}
  ${INDUSTRY_OFFERS_INFO}
`;

// Query by slug if needed
export const GET_INDUSTRY_BY_SLUG = gql`
  query ($slug: String!) {
    industries(filters: { slug: { eq: $slug } }) {
      ...IndustryBasicInfo
      ...IndustryMetaInfo
      ...IndustryServicesInfo
      ...IndustryProcessesInfo
      ...IndustryDemoInfo
      ...IndustryComparisonInfo
      ...IndustryOffersInfo
    }
  }
  ${INDUSTRY_BASIC_INFO}
  ${INDUSTRY_META_INFO}
  ${INDUSTRY_SERVICES_INFO}
  ${INDUSTRY_PROCESSES_INFO}
  ${INDUSTRY_DEMO_INFO}
  ${INDUSTRY_COMPARISON_INFO}
  ${INDUSTRY_OFFERS_INFO}
`;

// Composable functions
export function useGetIndustryById(documentId) {
  return useQuery(GET_INDUSTRY_BY_ID, { documentId });
}

export function useGetIndustryBySlug(slug) {
  return useQuery(GET_INDUSTRY_BY_SLUG, { slug });
}